import { useCommentsThreadQuery } from 'app/modules/posts/modules/post/components/postCommunication/comments/hooks/useCommentsThreadQuery';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';
import { ApprovalThreadType } from '../types';

type Props = {
  postId: number;
  thread: ApprovalThreadType;
};

export const useApprovalCommentsThreadQuery = ({ postId, thread }: Props) => {
  const postCommunicationContent: PostCommunicationContent =
    thread === 'internal'
      ? PostCommunicationContent.INTERNAL
      : PostCommunicationContent.CLIENT;

  return useCommentsThreadQuery({
    postId,
    thread: postCommunicationContent,
  });
};
